// extracted by mini-css-extract-plugin
var _1 = "InvoiceCreateCreditDialog_buttonWrapper__QHoTH";
var _2 = "InvoiceCreateCreditDialog_description__cpzXj";
export { _1 as "buttonWrapper", _2 as "description" }
